import {Component, OnInit} from '@angular/core';
import {UserService} from "../../../services/user.service";
import {NotificationService} from "../../../services/notification.service";
import {TenantService} from "../../../services/tenant.service";


@Component({
  selector: 'app-buyer',
  templateUrl: './buyer.component.html',
  styleUrls: ['./buyer.component.scss']
})
export class BuyerComponent implements OnInit {
  user: any = {};
  sideBarCollapsed = false;
  lastLogin = Date.now();
  notificationCount: number = 0;
  notifications: Array<any> = [];
  private intervalId: any;
  loggedInTenant;
  mainLogo;

  constructor(private userService: UserService,
              private notificationService: NotificationService,
              private tenantService: TenantService) {
    this.getTenant();
  }

  ngOnInit() {
    this.getUnReadNotificationsCount();
    this.getNotifications();
    this.intervalId = setInterval(() => {
      this.getUnReadNotificationsCount();
    }, 60000);
    this.getTenant();
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

  getTenant() {
    this.loggedInTenant = this.tenantService.getTenant();
    this.tenantService.subscribeForTenant().subscribe((response) => {
      this.loggedInTenant = response;
      this.mainLogo = response['logoUrl'];
      console.log(response)
    });
    this.userService.getCurrentUser()
      .then(user => {
        this.user = user;
        this.lastLogin = this.user.lastLoginTime ? this.user.lastLoginTime : this.lastLogin;
      });
  }
  logout() {
    this.userService.logout();
  }


  getUnReadNotificationsCount() {
    this.notificationService.getUnReadNotificationsCount()
      .subscribe(response => {
        if (this.notificationCount != response.count) {
          this.getNotifications()
        }
        this.notificationCount = response.count;
      })
  }

  getNotifications() {
    this.notificationService.getNotifications()
      .subscribe(response => {
        this.notifications = response;
      })
  }

  viewAllNotificationsFired() {
    if (this.notificationCount > 0) {
      this.notificationCount--;
    }
  }
  gotoMain(){
    window.location.href = window.location.origin + "/"

  }
}




// WEBPACK FOOTER //
// ./src/app/components/buyer/buyer/buyer.component.ts